import React, { useEffect } from 'react'

import type {
  CategoryWithChildren,
  CategoryWithParentCategory,
  StoryWithKeyIndicatorsCategoriesStoryImageAndResources,
} from '@aqua/db/types'

import { trpc } from '~/utils/api'
import StoryContent from './StoryContent'
import StoryHeader from './StoryHeader'

const Preview = ({
  story,
  categoryData,
}: {
  story: {
    storiesData: StoryWithKeyIndicatorsCategoriesStoryImageAndResources
    innermostParents: {
      storyId: number
      type: CategoryWithParentCategory
    }
  }
  categoryData: CategoryWithChildren[]
}) => {
  const { mutateAsync: increaseStoryCount } =
    trpc.stories.incrementStoryCount.useMutation()

  useEffect(() => {
    const onStoryWatched = async () => {
      try {
        await increaseStoryCount({ storyId: story.storiesData.id })
      } catch (error: any) {
        console.log('error in increasing the count', error.message)
      }
    }
    onStoryWatched()
  }, [])
  return (
    <div className=' w-full bg-[#edf2f7] pb-20 pt-14'>
      <div className='m-auto h-max w-[91%] max-w-[800px] lg:w-[80%]'>
        <div className='m-auto'>
          <StoryHeader
            storyData={story.storiesData}
            innerMostCategory={story.innermostParents}
            categoryData={categoryData}
          />
          <StoryContent categoryData={categoryData} story={story} />
        </div>
      </div>
    </div>
  )
}

export default Preview
